<script>
import resources from './resources'

export default {
  name: 'identification',

  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-identificacao-paciente.white-bg.wrapper.gadget.full-width
    div(v-if="!loading")
      .gadget-title
        | Meu Perfil
      .actions
        span.icon 
        ul
          li.exclude Remover
          li.half-width Lado a Lado
          li.full-width Tela Inteira
      .col-xs-8.col-xs-offset-2.col-md-2.col-md-offset-0.col-lg-offset-0.profile-picture
        img.img-circle(:src='user.avatar')
      .col-xs-12.col-md-7
        label.light-blue Nome do Titular
        h2.medium-gray {{ user.name }}
        label.light-blue Endereço Principal
        
        div(v-if="user.address_correspondence.street")
          h3.medium-gray {{ user.address_correspondence.street }}, {{ user.address_correspondence.number }}
            template(v-if="user.address_correspondence.complement")
              | - {{ user.address_correspondence.complement }}
          h4.medium-gray {{ user.address_correspondence.district }} - {{ user.address_correspondence.city }}, {{ user.address_correspondence.state }}
        
        div(v-if="!user.address_correspondence.street")
          h3.medium-gray  Não informado
          
      .half-width-margin
      .col-xs-12.col-md-3
        label.light-blue Convênios
        h2.medium-gray {{ covenants }}
        label.light-blue Telefone
        h3.medium-gray
          | {{ user.phones.mobile | phone }}
          template(v-if="user.phones.mobile && user.phones.work")
            br
          | {{ user.phones.work | phone }}
</template>



// WEBPACK FOOTER //
// src/app/patient/dashboard/gadget/components/identification/identification.vue